import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Calendar, ArrowRight } from 'lucide-react';
import { track } from '../utils/analytics';
import { openReservation } from '../utils/reservations';
import DiwaliPoster from './DiwaliPoster';
import { DIWALI_MAILTO, DIWALI_EMAIL, DIWALI_RESY_URL } from '../pages/DiwaliPage';

const GOLD = '#C9A86C';

const DiwaliBanner = () => (
  <section className="relative bg-[#0a0a0a] py-16 md:py-24 overflow-hidden" data-testid="home-diwali-banner">
    <img
      src="https://images.unsplash.com/photo-1601446052518-f793d82a4a97?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
      alt=""
      aria-hidden="true"
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover opacity-20"
    />
    <div className="absolute inset-0 bg-[#0a0a0a]/60" />
    <div className="relative max-w-7xl mx-auto px-6 grid md:grid-cols-[0.8fr_1.2fr] gap-10 md:gap-16 items-center">
      <DiwaliPoster testId="home-diwali-poster" />
      <div>
        <p className="text-[11px] uppercase tracking-[0.4em] mb-5" style={{ color: GOLD }}>
          Brick Lane Presents
        </p>
        <h2
          className="text-white mb-4"
          style={{ fontFamily: 'var(--font-serif)', fontSize: 'clamp(2rem, 5vw, 3.5rem)', lineHeight: '1.05' }}
        >
          Diwali Gala <span style={{ color: GOLD }}>2026</span>
        </h2>
        <p className="italic text-white/75 text-lg md:text-xl mb-8" style={{ fontFamily: 'var(--font-serif)' }}>
          Bites, Beats and Bright Lights
        </p>
        <div className="h-px w-20 mb-8" style={{ backgroundColor: GOLD }} />
        <p className="text-white text-base md:text-lg mb-2 tracking-wide">
          November 6 &amp; 7 &nbsp;·&nbsp; Doors 5:30 PM &nbsp;·&nbsp; Dinner 7:30 PM
        </p>
        <p className="text-white/60 text-sm md:text-base mb-10">
          Live appetizer stations, family-style grand feast, curated open bar, live DJ &amp; henna.
          $95 per person, plus tax, gratuity &amp; beverages. Book on Resy, or email {DIWALI_EMAIL}.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => openReservation(DIWALI_RESY_URL, 'home-diwali-banner')}
            data-testid="home-diwali-book-btn"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 text-xs md:text-sm uppercase tracking-[0.22em] hover:opacity-85 transition-opacity duration-300"
            style={{ backgroundColor: GOLD, color: '#0a0a0a' }}
          >
            <Calendar size={16} /> Book Now
          </button>
          <Link
            to="/diwali"
            data-testid="home-diwali-learn-more-btn"
            className="inline-flex items-center justify-center gap-2 px-9 py-4 text-xs md:text-sm uppercase tracking-[0.25em] text-white border border-white/30 hover:border-white transition-colors duration-300"
          >
            Explore the Gala <ArrowRight size={15} />
          </Link>
        </div>
        <a
          href={DIWALI_MAILTO}
          onClick={() => track('Contact', { content_name: 'Diwali Email Reservation', location: 'home-diwali-banner' })}
          data-testid="home-diwali-email-btn"
          className="inline-flex items-center gap-2 mt-6 text-xs md:text-sm tracking-[0.06em] text-white/60 hover:text-white transition-colors duration-300 break-all"
        >
          <Mail size={14} className="flex-shrink-0" /> {DIWALI_EMAIL}
        </a>
      </div>
    </div>
  </section>
);

export default DiwaliBanner;
